// ---------------------------------------------------------------------------
// QuoteTable-specific types.
//
// Generic column-editor types (`QuoteColumnType`, `ColumnConfig`,
// `DefaultRowConfig`) now live in the shared `SpreadsheetEditor` module and
// are re-exported here for backward compatibility with existing callers.
// ---------------------------------------------------------------------------

export type {
	ColumnConfig,
	DefaultRowConfig,
	QuoteColumnType,
} from "../SpreadsheetEditor/column-types";

import type { ColumnConfig, DefaultRowConfig } from "../SpreadsheetEditor/column-types";

/**
 * Mode determines how quote table components render:
 * - "edit": Procurer creation mode — full column/row CRUD, structural editing
 * - "respond": Bidder submission mode — suppliers fill in values
 * - "view": Read-only mode — no editing allowed
 */
export type QuoteTableMode = 'edit' | 'respond' | 'view';

export interface QuoteTableColumn {
    id: number;
    columnType: import("../SpreadsheetEditor/column-types").QuoteColumnType;
    isDefault?: boolean;
    isSupplierEditable?: boolean;
    label: string;
    sortOrder: number;
}

export interface QuoteTableRow {
    name: string;
    columnValues?: Record<number, string>;
    createdByType?: 'client' | 'supplier';
    itemId: number;
    quantity: number;
    quantityCategories?: Record<number, { quantity: number; rate: number }>;
    rate: number;
    unitId?: number;
    unitLabel?: string;
}

export interface SupplierRow {
    columnValues?: Record<number, string>;
    description: string;
    localId: string;
    quantity: string;
    rate: string;
    savedId?: number;
    unitId: number | null;
}

export interface ColumnHeader {
    columnId?: number;
    columnType?: import("../SpreadsheetEditor/column-types").QuoteColumnType;
    isDefault?: boolean;
    isFirstOfGroup?: boolean;
    key: string;
    label: string;
    width: string;
}

export interface QuoteTableConfig {
    name: string;
    columns: ColumnConfig[];
    defaultRows?: DefaultRowConfig[];
    description: string;
    presetType?: string;
}

export const CELL_BORDER = "border border-[#EAECF0]";
export const COLUMN_STYLE = "pl-2 font-roboto text-sm bg-gray-50";
